import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Layout from "../components/feature/Layout";
import Home from "../pages/home/page";
import CategoryPage from "../pages/category/page";
import ListPage from "../pages/list/page";
import DetailPage from "../pages/detail/page";
import SearchPage from "../pages/search/page";
import AboutUs from "../pages/about-us/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "category/movie", element: <CategoryPage type="movie" /> },
      { path: "category/tv", element: <CategoryPage type="tv" /> },
      { path: "list", element: <ListPage /> },
      { path: "detail/:id", element: <DetailPage /> },
      { path: "search", element: <SearchPage /> },
      { path: "about-us", element: <AboutUs /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;